import http from "./http";

class RolesusersService {
    index_roles_users(){
        return http.get("/api/rolesusers")
    }

}

export default new RolesusersService()